import { t } from '@base/utils/helpers';
import styles from '../styles/createTable.module.scss';
import { CreateTableTooltip } from './createTableTooltip';

export default function CreateTableBlock(props: { children: JSX.Element[] | JSX.Element; tooltip?: string }) {
  return (
    <div className={styles.item}>
      {props.children}
      {props.tooltip && (
        <CreateTableTooltip>
          <p>{t(props.tooltip)}</p>
        </CreateTableTooltip>
      )}
    </div>
  );
}
